module.exports = __webpack_public_path__ + "img/occupancy-detector-lg-occupied.ed676463.svg";